import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const InternationalMedicalExpenses = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'internationalMedicalExpenses',
  });

  return {
    title: t('title'),
    note: t('note'),
    coverages: [
      {
        label: t('medical.label'),
        remarks: t('medical.remarks', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: 'RM100,000' }),
            remark: t('remarkPerFamily', { amount: 'RM250,000' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amount', { amount: 'RM300,000' }),
            remark: t('remarkPerFamily', { amount: 'RM750,000' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amount', { amount: 'RM500,000' }),
            remark: t('remarkPerFamily', { amount: 'RM1,500,000' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('follow.label'),
        remarks: t('follow.remarks', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: 'RM5,000' }),
            remark: t('remarkPerFamily', { amount: 'RM12,500' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amount', { amount: 'RM10,000' }),
            remark: t('remarkPerFamily', { amount: 'RM25,000' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amount', { amount: 'RM30,000' }),
            remark: t('remarkPerFamily', { amount: 'RM75,000' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('alternative.label'),
        remarks: t('alternative.remarks', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: '-' }),
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amount', { amount: '-' }),
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amount', { amount: 'RM1,000' }),
            remark: t('remarkPerFamily', { amount: 'RM2,500' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('compassionate.label'),
        remarks: t('compassionate.remarks', { returnObjects: true }),
        remark: t('compassionate.remark', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: 'RM5,000' }),
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('care.label'),
        remarks: t('care.remarks', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: 'RM5,000' }),
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('daily.label'),
        remarks: t('daily.remarks', { returnObjects: true }),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amountPerDay', { amount: 'RM150' }),
            remark: t('remarkPerFamily', { amount: 'RM7,500' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amountPerDay', { amount: 'RM250' }),
            remark: t('remarkPerFamily', { amount: 'RM12,500' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amountPerDay', { amount: 'RM350' }),
            remark: t('remarkPerFamily', { amount: 'RM17,500' }),
            colspan: 1,
          },
        ],
      },
    ],
  };
};

export default InternationalMedicalExpenses;
